import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import productoService from '../services/productoService';
import './StockCounter.css';

const STOCK_UPDATE_EVENT = 'stock:updated';

const StockCounter = () => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();
  const [totalUnidades, setTotalUnidades] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchStock = useCallback(async () => {
    if (!isAuthenticated || !user) return;
    setError(false);
    try {
      const params = user.rol !== 'admin' && user.sucursal
        ? { sucursal: user.sucursal }
        : {};

      const response = await productoService.getProductos(params);
      const productos = response.data || [];

      let unidades = 0;
      productos.forEach(p => {
        if (user.rol === 'admin') {
          p.stockPorSucursal?.forEach(s => {
            unidades += s.cantidad || 0;
          });
        } else {
          const stockSucursal = p.stockPorSucursal?.find(
            s => s.sucursal?.toLowerCase() === user.sucursal?.toLowerCase()
          );
          unidades += stockSucursal?.cantidad || 0;
        }
      });

      setTotalUnidades(unidades);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user]);

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchStock();
    const interval = setInterval(fetchStock, 30000);

    const handleStockUpdated = () => {
      fetchStock();
    };

    window.addEventListener(STOCK_UPDATE_EVENT, handleStockUpdated);

    return () => {
      clearInterval(interval);
      window.removeEventListener(STOCK_UPDATE_EVENT, handleStockUpdated);
    };
  }, [isAuthenticated, fetchStock]);

  if (!isAuthenticated || !user || location.pathname === '/') return null;

  return (
    <div className="stock-counter" onClick={fetchStock} title="Click para actualizar">
      <div className="stock-counter-icon">📦</div>
      <div className="stock-counter-body">
        {loading ? (
          <div className="stock-counter-value loading">Cargando...</div>
        ) : error ? (
          <div className="stock-counter-value error">Error al cargar</div>
        ) : (
          <div className="stock-counter-value">
            <strong>{totalUnidades}</strong> stock
          </div>
        )}
      </div>
    </div>
  );
};

export default StockCounter;
